import React from 'react'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import PaletteProvider from 'contexts/PaletteProvider'
import Heading from 'components/Luxkit/Typography/Heading'
import { RouteComponentProps, withRouter } from 'react-router'
import { SupportedDestinations } from 'home/constants'
import { rem } from 'polished'
import styled from 'styled-components'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import HeroOfferLoadingCarousel from '../LETVLandingPage/HeroOfferLoadingCarousel'
import HotelOfferCardItem from '../LETVLandingPage/HotelOfferCardItems'
import FullWidthCarousel from 'components/Luxkit/Carousel/FullWidthCarousel'

const HeroCarouselContainer = styled(Pane)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(64)};
`

interface Props extends RouteComponentProps<{ destination: SupportedDestinations }> {
  className?: string;
  header: string;
  title: string;
  filters?: App.OfferListFilters;
}

function LETVHeroOfferCarousel({ header, title, className, filters }: Props) {
  return (
    <HeroCarouselContainer className={className} type="light">
      <Group direction="vertical" gap={24}>
        <LayoutContainer size="lg">
          <Heading variant="heading2">
            {title} <i>{header}</i>
          </Heading>
        </LayoutContainer>
        <CSSBreakpoint min="desktop">
          <PaletteProvider type="default">
            <FullWidthCarousel >
              {filters?.offerTypes?.map(offerType => <HeroOfferLoadingCarousel key={offerType} filters={{ ...filters, offerTypes: [offerType] }} hasLFSECarousel={false}/>)}
            </FullWidthCarousel>
          </PaletteProvider>
        </CSSBreakpoint>
        <CSSBreakpoint max="tablet">
          <FullWidthCarousel>
            {filters?.offerTypes?.map(offerType => <HotelOfferCardItem key={offerType} filters={{ ...filters, offerTypes: [offerType] }} hasLFSECarousel={false}/>)}
          </FullWidthCarousel>
        </CSSBreakpoint>
      </Group>
    </HeroCarouselContainer>
  )
}

export default withRouter(LETVHeroOfferCarousel)
